import { Injectable, EventEmitter, Inject, isDevMode } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { TokenHttp } from '../services/tokenhttp.service';
import { BootConstants } from '../boot.constants';
import { IChangePassword } from '../interfaces/IChangePassword';
import { map } from 'rxjs/operators';
import { BaseRepository } from './base.repository';
import { IDepot } from '../interfaces/IDepot';
import { IPlant } from '../interfaces/IPlant';
;

@Injectable()
export class LocationRepository extends BaseRepository {

    constructor(tokenHttp: TokenHttp) { 
        super(tokenHttp);
    }

    public plants(): Observable<IPlant[]> {
        return this.mapGet("locations/plants");
    }

    public depots(): Observable<IDepot[]> {
        return this.mapGet("locations/depots");
    }


}